import { ConfigProvider, Drawer, Table, Tag } from 'antd'
import './App.css'
import {getData} from './Data'
import { useEffect, useState } from 'react'
import { Project } from './Project'
import { Theme } from './Theme'

const App = () => {

  const [openProject, setOpenProject] = useState(false)
  const [project, setProject] = useState({})

  useEffect(()=> {
    if (openProject) {
      var iframeHeight = (document.getElementsByClassName('ant-drawer-body')[0].scrollHeight + 65) + 'px'
      window.parent.postMessage({ height: iframeHeight }, '*')
    } 
    else window.parent.postMessage({ height: (document.body.scrollHeight + 20) + 'px' }, '*') 
  }, [openProject])

  return <>
    <ConfigProvider theme={Theme}>
      <div className="App">
        <Table style={{height: '100%'}} scroll={{x: true}} columns={[
          {
            title: 'Project name',
            dataIndex: 'name'
          }, {
            title: 'Country',
            dataIndex: 'country'
          }, {
            title: 'Type',
            dataIndex: 'type'
          }, {
            title: 'Programme',
            dataIndex: 'programme'
          }, {
            title: 'Methodology',
            dataIndex: 'methodology'
          }, {
            title: 'Status',
            dataIndex: 'status',
            render: (tag) => <Tag color={'green'}>{tag}</Tag>
          }, {
            title: 'Developer',
            dataIndex: 'developer'
          }, {
            title: 'Hectares',
            dataIndex: 'hectares'
          }
        ]} dataSource={getData().projects} pagination={false} onRow={(record, rowIndex) => {
          return {
            onClick: (event) => {
              setProject(record)
              setOpenProject(true)
            }
          }
        }} bordered>
        </Table>
        
        <Drawer
          mask={false}
          destroyOnClose={true} 
          onClose={() => setOpenProject(false)}
          open={openProject} 
          title={project.name} 
          width={'100vw'}>
          <Project project={project} />
        </Drawer>
      </div>
    </ConfigProvider>
  </>
}

export default App
